import script from "./TabManager.vue?vue&type=script&setup=true&lang=js"
export * from "./TabManager.vue?vue&type=script&setup=true&lang=js"

import "./TabManager.vue?vue&type=style&index=0&id=2da8baca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2da8baca"]])

export default __exports__